import { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext, formatListData } from 'commons-ui';
import useService from '../../utils/useService';

const useVersionList = () => {
	const [showLoader, setShowLoader] = useState(false);
	const location = useLocation();
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { getAllExperimentVersion, requestRevertExperiment } = useService();
	const data = _get(location, ['state', 'rowData']);

	const abVerstionDatFormatter = (abVersionRow: any) => {
		return {
			abTestId: abVersionRow.abTestId,
			buckets: abVersionRow.abtest.buckets,
			name: abVersionRow.abtest.name,
			_id: abVersionRow._id,
			createdAt: abVersionRow.createdAt
		};
	};

	const getVersionsForExperiment = async (abTestId: string) => {
		const versionData = (await getAllExperimentVersion({ abTestId })) || [];
		const listData = formatListData(versionData.abTestVersions, '_id', abVerstionDatFormatter);
		if (versionData.isLimitReached) {
			showAlert('Limit reached for the given versions, please contact owners to get more in list.', {
				type: 'error',
				duration: 'LONG'
			});
		}
		return {
			rowCount: listData.length,
			data: listData
		};
	};

	const revertExperimentToVersion = async (abTestId: string, versionId: string) => {
		setShowLoader(true);
		requestRevertExperiment({ versionId, abTestId }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || res?.data?.externalMessage || 'Error occured while reverting experiment', {
						type: 'error'
					});
					setShowLoader(false);
					return;
				}
				showAlert('Experiment successfully reverted');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.externalMessage || err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	return {
		data,
		getVersionsForExperiment,
		revertExperimentToVersion,
		showLoader,
		setShowLoader
	};
};

export default useVersionList;
